import { useVisitPageParams } from './utils';
import { Visit } from '../../features/visits/Visit';
import { SuspenseWrapper } from '~/shared/SuspenseWrapper';
import { InitialAssessmentPrompt } from '~/features/visits/buckets/initial-assessment/InitialAssessmentPrompt';

export function VisitPage() {
	const { visitId } = useVisitPageParams();

	return (
		<SuspenseWrapper name="VisitPage" key={visitId}>
			<div className="flex min-h-0 flex-1 flex-col overflow-hidden">
				<Visit />
			</div>
			<InitialAssessmentPrompt />
		</SuspenseWrapper>
	);
}
